import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import loadable from '@loadable/component';
import { useIntl } from 'react-intl';
import { CurrencyPicker } from '@dmm/lib-react-ui-components';
import { definedValue } from '../../../../utils';
import { getFSBOUrl } from '../../../../utils/urlHelpers/fsbo';
import LanguagePicker from '../../../LanguagePicker';
import { SRP_LITERALS, useCurrency } from '../../../../pages/SearchResults/components/RefineSearch/FilterHelpers/useSRPFilters';
import { setSRPCurrency } from '../../../../store/actions';
import { parseSearchParams } from '../../../../utils/urlHelpers/urlPathParse';
import { getMessages } from '../../../../tppServices/translations/messages';
import { setNavigationEvent } from '../../../../store/actions/dataLayer';

const KeywordSearch = loadable(() => import('../../../KeywordSearch'));
// We might want to move this to the constants file.
const pagesAllowedShowCurrencyDropdown = ["SearchResults", "BrandedSearch", "BrandedOEMSearchResults"];

const TopHeader = (props) => {

    const dispatch = useDispatch();
    const intl = useIntl();
    const { formatMessage: t } = intl;
    const messages = getMessages();

    const {
        location,
        pageType,
        isWorking,
        isMobile,
        context,
        searchboxDesktop
    } = props;

    const fsboCTA = definedValue(context.fsboCTA, true);
    const sellBoatUrl = getFSBOUrl();
    let isUsersCurrencyEnabled = !!context?.isUsersCurrencyEnabled;
    const isCurrencyDropdownEnabled = isUsersCurrencyEnabled && pagesAllowedShowCurrencyDropdown.includes(pageType);
    const keywordSearchOptions = context.keywordSearchOptions;

    const urlParams = parseSearchParams(location?.pathname);

    const { selectedCurrency: userCurrency } = useCurrency(urlParams?.currency);

    const trackGenericClick = (event) => {
        dispatch(setNavigationEvent(event));
    };

    return (
        <>
            <div className="right-nav">
                {fsboCTA && (
                    <div className="cta-wrapper">
                        <a
                            id="nav-fsbo-cta"
                            className="nav-cta"
                            href={sellBoatUrl}
                            onClick={() => {
                                trackGenericClick({
                                    action: 'sell your boat',
                                    label: 'sell your boat'
                                });
                            }}
                        >
                            {t(messages.header.callToAction)}
                        </a>
                    </div>
                )}
                {context.multiLanguage && <LanguagePicker />}
                {searchboxDesktop && isCurrencyDropdownEnabled && (
                    <div className="currency-picker" >
                        <CurrencyPicker
                            selected={userCurrency}
                            onChange={(e, value) => {
                                e.preventDefault();
                                dispatch(setSRPCurrency(value));
                            }}
                            items={SRP_LITERALS.CURRENCIES}
                        />
                    </div>
                )}
                <div className="header-login">
                    <div className="header-login-icon">
                        <div className="header-login-head"></div>
                        <div className="header-login-body"></div>
                    </div>
                    <div>Login</div>
                </div>
                {searchboxDesktop && context.keywordSearch && (
                    <div className={
                        classnames('keyword-container-desktop', {
                            'keyword-container-circle': isCurrencyDropdownEnabled
                        })
                    }>
                        {' '}
                        <KeywordSearch
                            intl={intl}
                            keywordSearchOptions={keywordSearchOptions}
                            isWorking={isWorking}
                        />{' '}
                    </div>
                )}
            </div>
            {isMobile && context.keywordSearch && (
                <div className="keyword-container-mobile">
                    {' '}
                    <KeywordSearch
                        intl={intl}
                        keywordSearchOptions={keywordSearchOptions}
                        isWorking={isWorking}
                    />{' '}
                </div>
            )}
        </>
    );
};

TopHeader.propTypes = {
    isWorking: PropTypes.bool,
    pageType: PropTypes.string,
    isMobile: PropTypes.bool,
    location: PropTypes.object,
    context: PropTypes.object,
    searchboxDesktop: PropTypes.bool
};

export default TopHeader;
